import { Component } from '@angular/core';

@Component({
    selector: 'red-pencil-on-blue-pencil-svg',
    templateUrl: '../../../../../../src/assets/svgs/red-pencil-on-blue-pencil.svg',
    styleUrls: ['../svg.component.scss']
})
export class RedPencilOnBluePencilSVG {

}